// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"create-report-modal_btnWrapper__1hqqm","label":"create-report-modal_label__22IEt"};